var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import Checkbox from "react-icheck/lib/Checkbox";
import classNames from "classnames";
import * as userSettingsActions from "../../actions/userSettings";

import styles from "./UserSettings.css";
import checkStyles from "../../../styles/icheck/square/blue.css";

var SubscriptionSettings = function (_Component) {
  _inherits(SubscriptionSettings, _Component);

  function SubscriptionSettings() {
    _classCallCheck(this, SubscriptionSettings);

    var _this = _possibleConstructorReturn(this, (SubscriptionSettings.__proto__ || Object.getPrototypeOf(SubscriptionSettings)).call(this));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  _createClass(SubscriptionSettings, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.props.userSettingsActions.toggleCheckbox(this.props.userSettings.data.profileInfo.subscriptionIds, event.target.name, event.target.checked);
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      this.props.userSettingsActions.submitSubscriptions(this.props.userSettings.data.profileInfo.subscriptionIds);
    }
  }, {
    key: "createNewsletterName",
    value: function createNewsletterName(name) {
      // Pluralize the newsletter names if found in the lookup
      var lookups = {
        "alert": "Alerts",
        "newsletter": "Newsletters"
      };

      var newName = lookups[name] || name;

      return newName.toUpperCase();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(
        "div",
        { className: classNames(styles.infoWrapper, styles.marginTop20) },
        React.createElement(
          "div",
          { className: styles.blueHeading },
          "EMAIL SUBSCRIPTIONS"
        ),
        Object.keys(this.props.userSettings.data.subscriptions).map(function (key, kIndex) {
          var subscriptions = _this2.props.userSettings.data.subscriptions[key];

          return React.createElement(
            Row,
            { key: kIndex, className: styles.marginTop20 },
            React.createElement(
              Col,
              { lg: "2", sm: "12", xs: "12", className: styles.muted },
              _this2.createNewsletterName(key)
            ),
            React.createElement(
              Col,
              { lg: "10", sm: "12", xs: "12" },
              React.createElement(
                Row,
                { className: styles.checkboxContainer },
                subscriptions.map(function (subscription, sIndex) {
                  return React.createElement(
                    Col,
                    { key: sIndex, lg: "6", sm: "12", xs: "12" },
                    React.createElement(
                      "div",
                      { className: styles.checkboxes },
                      React.createElement(Checkbox, { onChange: _this2.handleChange, name: subscription.id, checkboxClass: checkStyles["icheckbox_square-blue"], checkedClass: checkStyles.checked, label: subscription.name, checked: _this2.props.userSettings.data.profileInfo.subscriptionIds.indexOf(subscription.id) >= 0 })
                    )
                  );
                })
              )
            )
          );
        }),
        React.createElement(
          "div",
          { className: styles.textCenter },
          React.createElement(
            "button",
            { onClick: this.handleSubmit, type: "button", className: classNames(styles.marginTop40, styles.blueButton1, styles.mobileBlock, styles.saveSubscriptionsButton) },
            "Save changes"
          )
        )
      );
    }
  }]);

  return SubscriptionSettings;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userSettingsActions: bindActionCreators(userSettingsActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionSettings);


// WEBPACK FOOTER //
// ./src/users/components/UserSettings/SubscriptionSettings.js